import { useEffect } from 'react';
import useDeepCompareMemoize from './useDeepCompareMemoize';

/**
 * Runs an effect keyed on deep rather than reference equality of its dependencies. Passes the deep-memoized dependency array to useEffect and returns the supplied cleanup from it.
 *
 * @param callback - Effect body to run.
 * @param dependencies - Dependencies compared deeply; defaults to an empty list.
 * @param cleanup - Teardown returned from the effect.
 * @returns Nothing.
 */
const useDeepCompareEffect = (
  callback: () => void,
  dependencies: unknown[] = [],
  cleanup?: () => void,
) => {
  useEffect(() => {
    callback();
    return cleanup;
  }, useDeepCompareMemoize(dependencies));
};

export default useDeepCompareEffect;
